module.exports = __webpack_public_path__ + "static/media/28-3.dbc2d814.mp3";